import { useSyncExternalStore } from 'react'
import { pubSub } from '../../app-state/pubSub'
import { getGridStateSelector } from '../../app-state/state.grid'

const subGrid = (callback) => pubSub.GRID.on('state', callback)
const getAvatarInfoOpen = (id: number) => () =>
    getGridStateSelector('avatarInfoOpenID') === id

export const useGridAvatarInfoOpenAppState = (id: number): boolean => {
    return useSyncExternalStore(
        subGrid,
        getAvatarInfoOpen(id),
        getAvatarInfoOpen(id),
    )
}
